import { createSlice } from "@reduxjs/toolkit";
import { postRequest } from "../../services/apiCaller/cl_index";
import { endpoints } from "../../api/ApiEndPoints";
import { setAffiliateCode, setErrorMessage } from "../signUp/cl_SignUpSlice";

const initialState = {
  coinsHistoryData: "",
  updatedGamesList: false,
  isModalOpen: false,
  showLevelModal: false,
  showRedeemPopUp: false,
  selectedGamesList: [],
  isListGamesSave: false,
  affiliateRes: [],
  affiSuggestedGames: [],
  affiliatedId: [],
  successMsg: false,
  vipreportData: [],
  selectedUserName: "",
  userNameErrMsg: "",
  displayPopup: true,
  affiliateDetailsData: [],
  viewAllModal: false,
  affiliatesData: [],
  initialSelectedGames: [],
  allEarnLoader: false,
  loader: false,
  recommendedUserName: [],
  gamesRecentlyPlayed: [],
  referralDetails: [],
};

export const coinsHistorySlice = createSlice({
  name: "coinsHistory",
  initialState,
  reducers: {
    setCoinsHistoryData: (state, action) => {
      state.coinsHistoryData = action.payload;
    },
    setAllEarnLoader: (state, action) => {
      state.allEarnLoader = action.payload;
    },
    setViewAllModal: (state, action) => {
      state.viewAllModal = action.payload;
    },
    setUpdatedGamesList: (state, action) => {
      state.updatedGamesList = action.payload;
    },
    setDisplayPopup: (state, action) => {
      state.displayPopup = action.payload;
    },
    setIsmodalOpen: (state, action) => {
      state.isModalOpen = action.payload;
    },
    setShowRedeemPopUp: (state, action) => {
      state.showRedeemPopUp = action.payload;
    },
    setShowLevelModal: (state, action) => {
      state.showLevelModal = action.payload;
    },
    setSelectedGamesList: (state, action) => {
      state.selectedGamesList = action.payload;
    },
    setIsListGamesSave: (state, action) => {
      state.isListGamesSave = action.payload;
    },
    setAffiliateResponse: (state, action) => {
      state.affiliateRes = action.payload;
    },
    setAffiSuggestedGames: (state, action) => {
      state.affiSuggestedGames = action.payload;
    },

    setSuccessMessage: (state, action) => {
      state.successMsg = action.payload;
    },
    setVIPReportData: (state, action) => {
      state.vipreportData = action.payload;
    },
    setSelectedUserName: (state, action) => {
      state.selectedUserName = action.payload;
    },
    setUserNameErrMsg: (state, action) => {
      state.userNameErrMsg = action.payload;
    },
    setAffiliateDetailsData: (state, action) => {
      state.affiliateDetailsData = action.payload;
    },
    setAffiliatesData: (state, action) => {
      state.affiliatesData = action.payload;
    },
    setInitialSelectedGames: (state, action) => {
      state.initialSelectedGames = action.payload;
    },
    setLoader: (state, action) => {
      state.loader = action.payload;
    },
    setRecommendedUserName: (state, action) => {
      state.recommendedUserName = action.payload;
    },
    setGamesRecentlyPlayed: (state, action) => {
      state.gamesRecentlyPlayed = action.payload;
    },
    setReferralDetails: (state, action) => {
      state.referralDetails = action.payload;
    },
  },
});

export const {
  setCoinsHistoryData,
  setUpdatedGamesList,
  setIsmodalOpen,
  setSelectedGamesList,
  setIsListGamesSave,
  setAffiliateResponse,
  setAffiSuggestedGames,
  setSuccessMessage,
  setVIPReportData,
  setSelectedUserName,
  setAllEarnLoader,
  setUserNameErrMsg,
  setDisplayPopup,
  setAffiliateDetailsData,
  setViewAllModal,
  setAffiliatesData,
  setInitialSelectedGames,
  setLoader,
  setRecommendedUserName,
  setGamesRecentlyPlayed,
  setReferralDetails,
  setShowLevelModal,
  setShowRedeemPopUp,
} = coinsHistorySlice.actions;

export default coinsHistorySlice.reducer;

export const coinsHistory = (userId, transactionType) => (dispatch) => {
  let url = endpoints.coinsHistory;
  dispatch(setLoader(true));

  const payload = {
    operatorId: "fasfas",
    platformId: 1,
    brand: "fasfas",
    userId: userId.toString(),
    // transactionType: transactionType
  };
  if (transactionType !== "ALL") {
    payload.transactionType = transactionType;
  }

  const headers = new Headers();
  headers.append(
    "Authorization",
    "Basic " +
      btoa(endpoints?.loyaltyUsername + ":" + endpoints?.loyaltyPassword)
  );
  headers.append("Content-Type", "application/json");
  fetch(url, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(payload),
  })
    .then((res) => {
      if (res.status === 200) {
        return res.json();
      } else {
        throw new Error("Failed to fetch data");
      }
    })
    .then((data) => {
      dispatch(setCoinsHistoryData(data?.result?.data));
      dispatch(setLoader(false));
    })
    .catch((error) => {
      console.error("Error fetching data: ", error);
      dispatch(setCoinsHistoryData(""));
      dispatch(setLoader(false));
    });
};

export const getUpdatedGamesList =
  (userId, refId, listGanes, gametype, userName) => (dispatch) => {
    const selectedGameDetails = listGanes.map((game) => ({
      gameName: game.name,
      aggregator_type: game.aggregator || game.aggregator_type || '',
      provider: game.provider,
      game_code: game.game_code || game.gameCode,
      image: game.image || {
        url: game.icon || "",
        configurl: game.configurl || ""
      },
      gametype: game.active === false ? "remove" : "",
    }));

    const url = endpoints?.vipgamesList;
    const payload = {
      operatorId: "fasfas",
      platformId: 1,
      brand: "fasfas",
      userId: `${userId}`,
      affiliateId: refId,
      games: selectedGameDetails,
      userName: userName,
      // gametype: gametype === 'remove' || gametype === 'add' ? gametype : ''
    };
    const headers = new Headers();
    headers.append(
      "Authorization",
      "Basic " +
        btoa(endpoints?.loyaltyUsername + ":" + endpoints?.loyaltyPassword)
    );
    headers.append("Content-Type", "application/json");

    fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(payload),
    })
      .then((res) => {
        if (res.status === 200 || res.status === 400) {
          return res.json();
        } else {
          throw new Error("Failed to fetch data");
        }
      })
      .then((data) => {
        if (gametype === "init") {
          dispatch(gamesSelectedList(userId, refId, userName));
        }
        if (!gametype) {
          dispatch(setUpdatedGamesList(true));
          dispatch(gamesSelectedList(userId, refId, userName));
          if (data?.data?.code == 200) {
            dispatch(setSuccessMessage(true));
          }
          if (data?.data?.code == 500) {
            if (data?.data?.message === "Sorry username is taken") {
              dispatch(
                setUserNameErrMsg(
                  "Sorry, this name is already in use. Please choose another one."
                )
              );
            } else {
              dispatch(setUserNameErrMsg(data?.data?.message));
            }
          }
          // setTimeout(() => {
          //   dispatch(setSuccessMessage(false))
          // }, 4000)
        }
      })
      .catch((error) => {
        dispatch(setErrorMessage(error));
      });
  };
export const gamesSelectedList = (userId, refId, userName) => (dispatch) => {
  const url = endpoints?.selectedGameList;
  const payload = {
    operatorId: "fasfas",
    platformId: 1,
    brand: "fasfas",
    userId: `${userId}`,
    affiliateId: refId,
    userName: userName,
  };
  const headers = new Headers();
  headers.append(
    "Authorization",
    "Basic " +
      btoa(endpoints?.loyaltyUsername + ":" + endpoints?.loyaltyPassword)
  );
  headers.append("Content-Type", "application/json");
  dispatch(setLoader(true));
  fetch(url, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(payload),
  })
    .then((res) => {
      if (res.status === 200 || res.status === 400) {
        return res.json();
      } else {
        throw new Error("Failed to fetch data");
      }
    })
    .then((data) => {
      dispatch(setLoader(false));
      dispatch(setAffiliateCode(data?.data?.data?.affiliateId));
      dispatch(setSelectedUserName(data?.data?.data?.userName));
      if (data?.data?.data?.games.length > 0) {
        data?.data?.data?.games?.forEach((data) => {
          data.name = data.gameName;
        });
        dispatch(setUpdatedGamesList(true));
        dispatch(setSelectedGamesList(data?.data?.data?.games));
        dispatch(setInitialSelectedGames(data?.data?.data?.games));
      } else {
        dispatch(setUpdatedGamesList(false));
        dispatch(setSelectedGamesList([]));
        dispatch(setInitialSelectedGames([]));
      }
    })
    .catch((error) => {
      dispatch(setLoader(false));
      dispatch(setErrorMessage(error));
    });
};

export const generateAffiliate = (userdetails) => (dispatch) => {
  const url = endpoints?.affiliateRequest;
  const payload = {
    firstName: userdetails?.userName,
    lastName: userdetails?.userName,
    mobileNumber: userdetails?.userOtherInfo?.phone,
    commissionPercentage: endpoints.commissionPercentage,
    affiliatePin: endpoints.affiliatePin,
    userName: userdetails?.userName,
    setupCost: endpoints.setupCost,
    role: endpoints.role,
    password: endpoints.password,
    payoutCycle: endpoints.payoutCycle,
    channel: endpoints.channel,
    applyDefaultCommissionPercentage: true,
  };
  postRequest(url, payload)
    .then((res) => {
      if (res?.data?.result?.data) {
        dispatch(setAffiliateResponse(res?.data?.result?.data));
      } else {
        throw new Error("Failed to fetch data");
      }
    })
    .catch((error) => {
      dispatch(setErrorMessage(error.message));
    });
};
export const getAffiliateGames = (afId) => (dispatch) => {
  const url = endpoints?.affiliateGames;
  const payload = {
    operatorId: "fasfas",
    platformId: 1,
    brand: "fasfas",
    affiliateId: afId,
  };
  const headers = new Headers();
  headers.append(
    "Authorization",
    "Basic " +
      btoa(endpoints?.loyaltyUsername + ":" + endpoints?.loyaltyPassword)
  );
  headers.append("Content-Type", "application/json");

  fetch(url, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(payload),
  })
    .then((res) => {
      if (res.status === 200 || res.status === 400) {
        return res.json();
      } else {
        throw new Error("Failed to fetch data");
      }
    })
    .then((data) => {
      if (data?.data?.data?.games?.length > 0) {
        dispatch(setAffiSuggestedGames(data?.data?.data));
      }
    })
    .catch((error) => {
      dispatch(setErrorMessage(error?.message));
    });
};

export const generateVIPReport = (affiliateID, token) => (dispatch) => {
  const url = endpoints?.vipreport;
  const payload = {
    accessToken: token,
    bTag: affiliateID,
    channel: "Internet",
  };
  postRequest(url, payload)
    .then((res) => {
      if (res?.data?.result?.data) {
        dispatch(setVIPReportData(res?.data?.result?.data));
      } else {
        throw new Error("Failed to fetch data");
      }
    })
    .catch((error) => {
      dispatch(setErrorMessage(error.message));
    });
};

export const getAffiliateDetails =
  (start, end, affiliateId, pageNum, PageSize) => (dispatch) => {
    const url = endpoints?.allEarnings;
    dispatch(setAllEarnLoader(true));
    const headers = new Headers();
    headers.append("accept", "application/json");
    headers.append("Content-Type", "application/json");

    const payload = {
      bTag: affiliateId,
      channel: "Internet",
      endDate: end,
      itemsPerPage: PageSize,
      pageNumber: pageNum,
      startDate: start,
    };

    fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(payload),
    })
      .then((res) => {
        if (res.status === 200) {
          return res.json();
        } else {
          throw new Error("Failed to fetch data");
        }
      })
      .then((data) => {
        dispatch(setAffiliateDetailsData(data?.result?.data));
        dispatch(setAllEarnLoader(false));
      })
      .catch((error) => {
        dispatch(setAllEarnLoader(false));
        console.error("Error fetching data: ", error);
        // dispatch(setCoinsHistoryData(''))
      });
  };

export const getAffiliateEarnsData = (affiliateId) => (dispatch) => {
  const url = endpoints.affiliateData;
  const payload = {
    bTag: affiliateId,
    channel: "Internet",
  };
  postRequest(url, payload)
    .then((res) => {
      if (res?.data?.result?.data) {
        dispatch(setAffiliatesData(res?.data?.result?.data?.data[0]));
      } else {
        throw new Error("Failed to fetch data");
      }
    })
    .catch((error) => {
      dispatch(setErrorMessage(error.message));
    });
};

export const getAffiliateUserName = (afId) => (dispatch) => {
  const url = `${endpoints?.affiliateUserName}?affiliateId=${afId}`;

  const headers = new Headers();
  headers.append(
    "Authorization",
    "Basic " +
      btoa(endpoints?.loyaltyUsername + ":" + endpoints?.loyaltyPassword)
  );
  headers.append("Content-Type", "application/json");

  fetch(url, {
    method: "GET",
    headers: headers,
  })
    .then((res) => {
      if (res.status === 200) {
        return res.json();
      } else {
        throw new Error("Failed to fetch data");
      }
    })
    .then((data) => {
      dispatch(setRecommendedUserName(data?.data[0]));
      // You can dispatch the data to the store if needed here
      // dispatch(setAffiliateData(data));
    })
    .catch((error) => {
      console.error("Error:", error);
      dispatch(setErrorMessage(error?.message));
    });
};

export const recentlyPlayedGames = (token) => (dispatch) => {
  const url = endpoints?.recentlyPlayedGamesList;
  const payload = {
    accessToken: token,
    clientType: "mobile",
  };
  dispatch(setLoader(true));
  postRequest(url, payload)
    .then((res) => {
      if (res?.data?.result?.data) {
        dispatch(setLoader(false));
        dispatch(setGamesRecentlyPlayed(res?.data?.result?.data));
      } else {
        dispatch(setLoader(false));
        throw new Error("Failed to fetch data");
      }
    })
    .catch((error) => {
      dispatch(setLoader(false));
      dispatch(setErrorMessage(error.message));
    });
};

export const getReferralDetails = (token) => (dispatch) => {
  const url = endpoints?.referralList;
  const payload = {
    accessToken: token,
    clientType: "mobile",
  };
  dispatch(setLoader(true));
  postRequest(url, payload)
    .then((res) => {
      if (res?.data?.result) {
        dispatch(setLoader(false));
        dispatch(setReferralDetails(res?.data?.result));
        dispatch(setErrorMessage(res?.data?.result?.message));
      } else {
        dispatch(setLoader(false));
        dispatch(setErrorMessage(res?.data?.result?.message));
        throw new Error("Failed to fetch data");
      }
    })
    .catch((error) => {
      dispatch(setLoader(false));
      dispatch(setErrorMessage(error.message));
    });
};
